import React from 'react';

import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';

interface DataInboxPluginContainerProps {
  operationsSelected: Operation[]
}

interface DataInboxProps {
  operationSelected: Operation;
  operationUserId?: number;
}

// Runtime dependency
const DataInboxPlugin: React.FC<DataInboxProps> = React.lazy(() => importFromS3('data-inbox'));

export const DataInboxPluginContainer: React.FC<DataInboxPluginContainerProps> = ({ operationsSelected }: DataInboxPluginContainerProps) => {
  const { isLoading, operation } = useImpersonatedOperation();
  const operationSelected = operation || operationsSelected[0];

  // prevent rendering Data Inbox if we're fetching operations
  if (isLoading || !operationSelected?.operationOwnerId) return null;

  const operationUserId = Number(operationSelected.operationOwnerId);

  return (
    <DataInboxPlugin
      operationSelected={operationSelected}
      operationUserId={operationUserId}
    />
  );
};
